import { Modal } from "@mui/material";
import { useTranslation } from "react-i18next";

import Spinner from "../../../../../components/common/Spinner";
import styles from "./styles.module.scss";

interface AcceptSettlementModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading: boolean;
}

const AcceptSettlementModal = ({
  open,
  onClose,
  onConfirm,
  loading,
}: AcceptSettlementModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal open={open} onClose={onClose} className={styles.overlay}>
      <div className={styles.modal}>
        <button type="button" className={styles.closeBtn} onClick={onClose}>
          ✕
        </button>
        <div className={styles.content}>
          <img
            src="/assets/images/svg/Success_tick.svg"
            alt=""
            className={styles.successIcon}
          />
          <div className={styles.textSection}>
            <h2 className={styles.title}>
              {t("lbl_accept_settlement_confirm_title")}
            </h2>
            <p className={styles.desc}>
              {t("lbl_accept_settlement_confirm_desc")}
            </p>
          </div>
          <div className={styles.actions}>
            <button
              type="button"
              className={styles.confirmBtn}
              disabled={loading}
              onClick={onConfirm}>
              {loading ? <Spinner /> : t("lbl_confirm_accept")}
            </button>
            <button
              type="button"
              className={styles.cancelBtn}
              onClick={onClose}>
              {t("lbl_cancel")}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AcceptSettlementModal;
